import { useEffect, useState } from "react";
import { II } from "../../components/common/Icons";
import HrModal from "./HrModal";
import api from "../../services/api";import "../../assets/styles/HR/HrSettingsPg.css";

function HrSettingsPg() {
  const [leaveConfigs, setLeaveConfigs] = useState([]);
  const [payrollConfig, setPayrollConfig] = useState([["PF Rate", "12%"], ["TDS Slab", "As per IT Act"], ["Processing Day", "Last working day"], ["Third-party Processor", "PayTech Solutions"]]);
  const [permConfig, setPermConfig] = useState(null);
  const [editItem, setEditItem] = useState(null);
  const [editVal, setEditVal] = useState("");
  const [suc, setSuc] = useState("");
  const [saving, setSaving] = useState(false);
  const [showAddLeave, setShowAddLeave] = useState(false);
  const [newLeave, setNewLeave] = useState({ leave_type: "", total_per_year: 0, color: "#6366f1", is_active: true });

  useEffect(() => {
    api.getLeaveConfig().then((data) => {if (Array.isArray(data)) setLeaveConfigs(data);}).catch(() => {});
    api.getHrSettings().then((s) => {
      if (!s || typeof s !== "object") return;
      setPayrollConfig((prev) => prev.map(([k, v]) => [k, s[k] || v]));
    }).catch(() => {});
    api.getPermissionConfigHR().then((cfg) => {if (cfg) setPermConfig(cfg);}).catch(() => {});
  }, []);

  const updateLeaveType = (leaveType, field, value) => {
    setLeaveConfigs((prev) => prev.map((c) => String(c.leave_type) === String(leaveType) ? { ...c, [field]: field === "total_per_year" ? Number(value) : value } : c));
  };

  const addLeaveType = () => {
    if (!newLeave.leave_type.trim()) return;
    const exists = leaveConfigs.some((c) => String(c.leave_type).toLowerCase() === newLeave.leave_type.trim().toLowerCase());
    if (exists) {
      setSuc("Leave type already exists.");
      setTimeout(() => setSuc(""), 2500);
      return;
    }
    setLeaveConfigs((prev) => [...prev, { ...newLeave, leave_type: newLeave.leave_type.trim(), is_active: true }]);
    setNewLeave({ leave_type: "", total_per_year: 0, color: "#6366f1", is_active: true });
    setShowAddLeave(false);
  };

  const removeLeaveType = (leaveType) => {
    setLeaveConfigs((prev) => prev.map((c) => String(c.leave_type) === String(leaveType) ? { ...c, _deleted: true, is_active: false } : c));
  };

  const saveLeaveConfig = async () => {
    try {
      setSaving(true);
      await api.updateLeaveConfig(leaveConfigs);
      const fresh = await api.getLeaveConfig();
      setLeaveConfigs(Array.isArray(fresh) ? fresh : []);
      setSuc("Leave configuration saved and applied to all users!");
      setTimeout(() => setSuc(""), 4000);
    } catch (e) {
      setSuc("Error: " + e.message);
      setTimeout(() => setSuc(""), 4000);
    } finally {
      setSaving(false);
    }
  };

  const updatePermField = (field, val) => setPermConfig((prev) => ({ ...prev, [field]: val }));

  const savePermConfig = async () => {
    try {
      setSaving(true);
      await api.updatePermissionConfig(permConfig);
      setSuc("Permission (Short Leave) configuration saved!");
      setTimeout(() => setSuc(""), 4000);
    } catch (e) {
      setSuc("Error: " + e.message);
      setTimeout(() => setSuc(""), 4000);
    } finally {
      setSaving(false);
    }
  };

  const startEdit = (idx) => {setEditItem({ idx, label: payrollConfig[idx][0] });setEditVal(payrollConfig[idx][1]);};

  const saveEdit = async () => {
    if (!editItem) return;
    try {
      setSaving(true);
      await api.saveHrSetting(editItem.label, editVal);
      setPayrollConfig((prev) => prev.map((item, i) => i === editItem.idx ? [item[0], editVal] : item));
      setSuc(editItem.label + " updated to '" + editVal + "'");
      setEditItem(null);
      setEditVal("");
      setTimeout(() => setSuc(""), 4000);
    } catch (e) {
      setSuc("Error saving: " + e.message);
      setTimeout(() => setSuc(""), 4000);
    } finally {
      setSaving(false);
    }
  };

  const visibleLeaves = leaveConfigs.filter((c) => !c._deleted);

  return (
    <div>
      <div className="sec">Settings</div>
      {suc && <div className="toast">{II("chk", 16, { c: "#2563eb" })} {suc}</div>}
      <div className="g2">
        <div className="cd">
          <div className="cd-h">
            <div className="cd-t">Leave Configuration</div>
            <div className="hrsettingspg-inline-1">
              <button className="btn-o btn-s" onClick={() => setShowAddLeave(true)}>+ Add</button>
              <button className="btn btn-s" onClick={saveLeaveConfig} disabled={saving}>{saving ? "Saving..." : "Save All"}</button>
            </div>
          </div>
          <div className="cd-b hrsettingspg-inline-2">
            <table className="tbl hrsettingspg-inline-3">
              <thead><tr><th>Leave Type</th><th>Total / Year</th><th>Color</th><th>Active</th><th></th></tr></thead>
              <tbody>
                {visibleLeaves.map((c, i) =>
                <tr key={c.id || `${c.leave_type}-${i}`}>
                    <td className="hrsettingspg-inline-4">{c.leave_type}</td>
                    <td><input type="number" className="fi hrsettingspg-inline-5" value={c.total_per_year} onChange={(e) => updateLeaveType(c.leave_type, "total_per_year", e.target.value)} min="0" /></td>
                    <td><input type="color" value={c.color || "#6366f1"} onChange={(e) => updateLeaveType(c.leave_type, "color", e.target.value)} className="hrsettingspg-inline-6" /></td>
                    <td><input type="checkbox" checked={c.is_active !== false && c.is_active !== 0} onChange={(e) => updateLeaveType(c.leave_type, "is_active", e.target.checked)} /></td>
                    <td><button className="btn-o btn-s hrsettingspg-inline-7" onClick={() => removeLeaveType(c.leave_type)}>x</button></td>
                  </tr>
                )}
                {visibleLeaves.length === 0 && <tr><td colSpan="5" className="hrsettingspg-inline-8">No leave types</td></tr>}
              </tbody>
            </table>
          </div>
        </div>

        <div className="cd">
          <div className="cd-h">
            <div className="cd-t">Permission (Short Leave) Limits</div>
            <button className="btn btn-s" onClick={savePermConfig} disabled={saving}>{saving ? "Saving..." : "Save Config"}</button>
          </div>
          <div className="cd-b">
            {permConfig ?
            <div className="hrsettingspg-inline-9">
                <div className="pf"><div className="pf-l">Max Permissions / Month</div><input type="number" className="fi hrsettingspg-inline-10" value={permConfig.max_per_month} onChange={(e) => updatePermField("max_per_month", Number(e.target.value))} /></div>
                <div className="pf"><div className="pf-l">Max Hours / Day</div><input type="number" step="0.5" className="fi hrsettingspg-inline-11" value={permConfig.max_hours_per_day} onChange={(e) => updatePermField("max_hours_per_day", parseFloat(e.target.value))} /></div>
                <div className="pf"><div className="pf-l">Min Hours (Step)</div><input type="number" step="0.5" className="fi hrsettingspg-inline-12" value={permConfig.min_hours} onChange={(e) => updatePermField("min_hours", parseFloat(e.target.value))} /></div>
                <div className="pf"><div className="pf-l">Requires Manager Approval</div><input type="checkbox" checked={permConfig.requires_approval} onChange={(e) => updatePermField("requires_approval", e.target.checked)} /></div>
              </div> :
            <div className="hrsettingspg-inline-13">Loading configuration...</div>}
          </div>
        </div>

        <div className="cd">
          <div className="cd-h"><div className="cd-t">Payroll Settings</div></div>
          <div className="cd-b">
            {payrollConfig.map(([l, v], i) =>
            <div className="pf" key={i}>
                <div className="pf-l">{l}</div>
                <div className="hrsettingspg-inline-14">
                  <div className="pf-v">{v}</div>
                  <button className="btn-o hrsettingspg-inline-15" onClick={() => startEdit(i)}>{II("edit", 12)}</button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <HrModal open={showAddLeave} onClose={() => setShowAddLeave(false)} title="Add Leave Type">
        <div className="fg"><label className="fl">Leave Type</label><input className="fi" value={newLeave.leave_type} onChange={(e) => setNewLeave((v) => ({ ...v, leave_type: e.target.value }))} /></div>
        <div className="fg"><label className="fl">Total / Year</label><input type="number" className="fi" value={newLeave.total_per_year} onChange={(e) => setNewLeave((v) => ({ ...v, total_per_year: Number(e.target.value) }))} /></div>
        <div className="fg"><label className="fl">Color</label><input type="color" value={newLeave.color} onChange={(e) => setNewLeave((v) => ({ ...v, color: e.target.value }))} /></div>
        <div className="fg"><label className="fl">Active</label><input type="checkbox" checked={newLeave.is_active} onChange={(e) => setNewLeave((v) => ({ ...v, is_active: e.target.checked }))} /></div>
        <div className="fa"><button className="btn-o" onClick={() => setShowAddLeave(false)}>Cancel</button><button className="btn" onClick={addLeaveType}>Add</button></div>
      </HrModal>

      <HrModal open={editItem !== null} onClose={() => setEditItem(null)} title={"Edit: " + (editItem?.label || "")}>
        {editItem &&
        <div>
            <div className="fg"><label className="fl">{editItem.label}</label><input className="fi" value={editVal} onChange={(e) => setEditVal(e.target.value)} /></div>
            <div className="hrsettingspg-inline-16">
              <button className="btn-o" onClick={() => setEditItem(null)}>Cancel</button>
              <button className="btn" onClick={saveEdit} disabled={saving}>{saving ? "Saving..." : "Save"}</button>
            </div>
          </div>
        }
      </HrModal>
    </div>);

}

export default HrSettingsPg;